<script lang="ts">
  import { createItem, itemSuggestions } from "../stores/data";

  let { listId }: { listId: string } = $props();

  let name = $state("");
  let quantity = $state("");
  let unit = $state("");
  let expanded = $state(false);
  let showSuggestions = $state(false);

  const commonUnits = ["g", "kg", "ml", "l", "pcs", "pack"];

  // Ordered by frequency already (server sorts by count desc); just filter
  // down to what matches what's typed so far and cap how many show up.
  let filteredSuggestions = $derived.by(() => {
    const query = name.trim().toLowerCase();
    if (!query) return [];
    return $itemSuggestions
      .filter((s) => s.name.toLowerCase() !== query && s.name.toLowerCase().includes(query))
      .slice(0, 6);
  });

  function chooseSuggestion(suggestionName: string): void {
    name = suggestionName;
    showSuggestions = false;
  }

  function submit(event: SubmitEvent): void {
    event.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    const parsedQuantity = quantity.trim() ? Number(quantity) : null;
    void createItem(
      listId,
      trimmed,
      parsedQuantity !== null && Number.isFinite(parsedQuantity) ? parsedQuantity : null,
      unit.trim() || null,
    );
    name = "";
    quantity = "";
    unit = "";
    expanded = false;
    showSuggestions = false;
  }
</script>

<form class="add-bar" onsubmit={submit}>
  <div class="row">
    <div class="name-field">
      <input
        class="name"
        type="text"
        placeholder="Add an item…"
        bind:value={name}
        maxlength="200"
        autocomplete="off"
        oninput={() => (showSuggestions = true)}
        onfocus={() => (showSuggestions = true)}
        onblur={() => (showSuggestions = false)}
        onkeydown={(e) => {
          if (e.key === "Escape") showSuggestions = false;
        }}
      />
      {#if showSuggestions && filteredSuggestions.length > 0}
        <ul class="suggestions">
          {#each filteredSuggestions as suggestion (suggestion.name)}
            <li>
              <button
                type="button"
                onmousedown={(e) => {
                  e.preventDefault();
                  chooseSuggestion(suggestion.name);
                }}
              >
                {suggestion.name}
              </button>
            </li>
          {/each}
        </ul>
      {/if}
    </div>
    <button
      type="button"
      class="expand"
      aria-label={expanded ? "Hide quantity and unit" : "Add quantity and unit"}
      onclick={() => (expanded = !expanded)}
    >
      {expanded ? "−" : "+"}
    </button>
    <button type="submit" class="submit" aria-label="Add item">Add</button>
  </div>
  {#if expanded}
    <div class="row secondary">
      <input
        type="text"
        inputmode="decimal"
        placeholder="Qty"
        bind:value={quantity}
      />
      <input type="text" placeholder="Unit" list="units" bind:value={unit} maxlength="32" />
      <datalist id="units">
        {#each commonUnits as u (u)}
          <option value={u}></option>
        {/each}
      </datalist>
    </div>
  {/if}
</form>

<style>
  .add-bar {
    position: sticky;
    top: 0;
    z-index: 5;
    background: var(--surface);
    border-bottom: 1px solid var(--border);
    padding: 0.6rem;
    padding-left: max(0.6rem, env(safe-area-inset-left));
    padding-right: max(0.6rem, env(safe-area-inset-right));
  }
  .row {
    display: flex;
    gap: 0.5rem;
  }
  .row.secondary {
    margin-top: 0.5rem;
  }
  input {
    flex: 1;
    padding: 0.75rem;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    background: var(--bg);
    color: var(--text);
    font-size: 1rem;
    min-width: 0;
  }
  .row.secondary input {
    flex: 1;
  }
  .name-field {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;
  }
  .name {
    width: 100%;
  }
  .suggestions {
    position: absolute;
    top: calc(100% + 0.25rem);
    left: 0;
    right: 0;
    z-index: 10;
    margin: 0;
    padding: 0.25rem;
    list-style: none;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    max-height: 240px;
    overflow-y: auto;
  }
  .suggestions li button {
    display: block;
    width: 100%;
    text-align: left;
    padding: 0.6rem 0.65rem;
    border: none;
    border-radius: calc(var(--radius) - 4px);
    background: transparent;
    color: var(--text);
    font-size: 0.95rem;
    cursor: pointer;
  }
  .suggestions li button:hover,
  .suggestions li button:focus-visible {
    background: var(--surface-alt);
  }
  .expand,
  .submit {
    flex: 0 0 auto;
    border: none;
    border-radius: var(--radius);
    padding: 0 1rem;
    font-size: 1.1rem;
    cursor: pointer;
  }
  .expand {
    background: var(--surface-alt);
    color: var(--text);
    width: 3rem;
  }
  .submit {
    background: var(--accent);
    color: var(--accent-contrast);
    font-weight: 600;
  }
</style>
